import React from 'react'
import cx from 'classnames'
import { CardButton, Icon } from '@manychat/manyui'

import { KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

import { KnowledgeTypeOptions } from './lib/constants'

import cm from './styles.module.css'

interface KnowledgeActionCardsProps {
  onSelect: (type: KnowledgeEntryType) => void
  listClassName?: string
}

export const KnowledgeActionCards = ({ onSelect, listClassName }: KnowledgeActionCardsProps) => {
  return (
    <div className={cm.wrapper}>
      <ul className={cx(cm.entryOptions, listClassName)}>
        {KnowledgeTypeOptions.map((option, index) => {
          const IconComponent = Icon[option.icon]

          return (
            <li key={index}>
              <CardButton
                ariaLabel={option.ariaLabel}
                onClick={() => onSelect(option.entryType)}
                className={cm.knowledgeTypeCard}
                data-test-id={`ai-automation/knowledge-action-card-${option.entryType}`}
                buttonClassName={cm.knowledgeTypeCard__button}
              >
                <div className="d-flex justify-between">
                  <IconComponent size={20} aria-hidden="true" />
                </div>

                <h3
                  className={cx('m-0 text-subheading-sm text-nowrap', cm.knowledgeTypeCard__title)}
                >
                  {option.title}
                </h3>
              </CardButton>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
